import { Injectable } from '@angular/core';
import { RegionSelection } from './region-selection.service';

export interface PolicySimulationInputState {
    region_id: string;
    region_name?: string;
    region_type?: string;
    parent_region_id?: string | null;
    industry_code: string;
    industry_name?: string;
    goal_key: string;
    policy_goal?: string;
    weights: Record<string, number>;
    data_year?: number | null;
}

export interface PolicySimulationState {
    selection: RegionSelection | null;
    input: PolicySimulationInputState;
    result: any | null;
    updated_at: string;
}

@Injectable({ providedIn: 'root' })
export class PolicySimulationStateService {
    private readonly storageKey = 'reviewops-policy-simulation-state-v1';

    public read(): PolicySimulationState | null {
        try {
            const value = window.sessionStorage.getItem(this.storageKey);
            if (!value) return null;
            const state = JSON.parse(value);
            if (!state?.input || !state.input.region_id) return null;
            return state as PolicySimulationState;
        } catch (error) {
            return null;
        }
    }

    public save(
        selection: RegionSelection | null,
        input: PolicySimulationInputState,
        result: any | null,
    ): void {
        if (!selection?.region_id || !input?.region_id) return;
        const state: PolicySimulationState = {
            selection: { ...selection },
            input: {
                region_id: input.region_id,
                region_name: input.region_name || selection.region_name,
                region_type: input.region_type || selection.region_type,
                parent_region_id: input.parent_region_id ?? selection.parent_region_id,
                industry_code: input.industry_code || '',
                industry_name: input.industry_name || '',
                goal_key: input.goal_key || 'GROWTH_PROMOTION',
                policy_goal: input.policy_goal || input.goal_key || 'GROWTH_PROMOTION',
                weights: { ...(input.weights || {}) },
                data_year: input.data_year || null,
            },
            result,
            updated_at: new Date().toISOString(),
        };
        window.sessionStorage.setItem(this.storageKey, JSON.stringify(state));
    }

    public clear(): void {
        window.sessionStorage.removeItem(this.storageKey);
    }
}
